module.exports = __webpack_public_path__ + "static/img/Queen of Wands.5f4000d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Queen of Wands.jpg
// module id = 1294
// module chunks = 0